import { fetchContentPayload } from 'lib/contentful/api';
import { first } from 'lib/utils/helpers';

const fetchSlugs = async (locale, query) =>
  first(await fetchContentPayload({ query, variables: { locale } })).items;

const fetchLocaleSlugs = async (locales, query) =>
  locales.reduce(async (acc, locale) => {
    return {
      ...(await acc),
      [locale]: await fetchSlugs(locale, query),
    };
  }, {});

export default fetchLocaleSlugs;
